'use client'

import React from 'react'
import { useRouter } from 'next/navigation'

function BackButton() {
  const router = useRouter()
  return (
    <i
      onClick={() => router.back()}
      className='absolute right-6 top-6 text-onSecondary-5 z-10'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        strokeWidth={1.5}
        stroke='currentColor'
        className='size-5'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3'
        />
      </svg>
    </i>
  )
}

export default BackButton
